import React from 'react';

interface Props {
    message: string
    className?: string;
}

const ErrorAlertView = (props: Props) => {
    return (
        <div className={`alert alert-danger${props.className ? ` ${props.className}` : ""}`}>
            {props.message}
        </div>
    )
}

export default ErrorAlertView;
